import styled from "styled-components";
import Benefit_1 from "assets/images/login/benefit1.svg";
import { useNavigate, useParams } from "react-router-dom";
import React from "react";

const MarketRegistration = () => {
  const navigate = useNavigate();
  const { marketId } = useParams();
  const marketDetailBtnHandler = () => {
    navigate(`/market/${marketId}`);
  };
  return (
    <LoginWrapper>
      <SignupContainer>
        <Title>
          사업자 등록이 완료됐습니다 🎉
          <br />
          사장님만을 위한 혜택을 이용해 보세요!
        </Title>
        <Content>
          <img src={Benefit_1} style={{ width: "100%", marginTop: "3vh" }} />
        </Content>
      </SignupContainer>
      <Button onClick={marketDetailBtnHandler}>도매상 문의하러 가기</Button>
    </LoginWrapper>
  );
};

export default MarketRegistration;

const LoginWrapper = styled.div`
  position: relative;
  width: 90%;
  margin: auto;
  padding-top: 15px;
`;

const SignupContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 13vh;
`;

const Title = styled.div`
  font-size: 1.1em;
  font-weight: 700;
  margin-bottom: 2vh;
  text-align: center;
  letter-spacing: -0.02em;
`;

const Content = styled.div``;

const Button = styled.button`
  width: 100%;
  height: 56px;
  top: 500px;
  /* bottom: 30vh; */
  box-sizing: border-box;
  position: absolute;
  background: #ff7a00;
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  text-align: center;
  border-style: none;
  vertical-align: middle;
  cursor: pointer;
`;
